<template>
  <div class="auth-block">
    <NuxtIcon
      v-if="currentStep === 1"
      class="auth-block__back"
      name="back"
      filled
      @click="handleBack"
    />

    <div class="auth-block__content">
      <AuthPhone
        v-if="currentStep === 0"
        :is-loading="isLoading"
        :auth-status="authStatus"
        @submit="handlePhoneSubmit"
      />

      <AuthCode
        v-if="currentStep === 1"
        :is-loading="isLoading"
        :auth-status="authStatus"
        @submit="handleCodeSubmit"
        @back="handleBack"
      />

      <AuthSuccess
        v-if="currentStep === 2"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuth } from '@common/composables/useAuth';
import AuthPhone from '@common/components/popups/auth/AuthPhone.vue';
import AuthCode from '@common/components/popups/auth/AuthCode.vue';
import AuthSuccess from '@common/components/popups/auth/AuthSuccess.vue';

const {
  currentStep,
  isLoading,
  authStatus,
  handlePhoneSubmit,
  handleCodeSubmit,
  handleBack,
} = useAuth();
</script>

<style lang="scss" scoped>
.auth-block {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  &__back {
    position: absolute;
    top: 1.2rem;
    left: 1.2rem;
    cursor: pointer;
  }

  &__content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
